import React, { useEffect, useState } from 'react';
import DataTable from '@salesforce/design-system-react/module/components/data-table';
import DataTableColumn from '@salesforce/design-system-react/module/components/data-table/column';
import DataTableCell from '@salesforce/design-system-react/module/components/data-table/cell';
import DataTableInteractiveLink from '@salesforce/design-system-react/module/components/data-table/interactive-link';
import PageHeader from '@salesforce/design-system-react/module/components/page-header';
import { controls } from '../../components/Accounts/controls';
import { useDispatch, useSelector } from 'react-redux';
import { getClients, clientsSelector } from '../../store/clients/slice';
import { Button, ButtonGroup, Dropdown, PageHeaderControl } from '@salesforce/design-system-react';
import AddClient from '../../components/Modal/addClient';

const CustomDataTableCell = ({ children, ...props }) => (
  <DataTableCell title={children} {...props}>
    <DataTableInteractiveLink>{children}</DataTableInteractiveLink>
  </DataTableCell>
);
// need to figure what what this does
CustomDataTableCell.displayName = DataTableCell.displayName;

const CustomDataTableNotes = ({ children, ...props }) => {
  return (
    <td
      style={{
        backgroundColor: '#FAFFBD',
        padding: '10px 5px',
        color: '#000',
      }}
      title={children}
    >
      <div className="slds-truncate">{children}</div>
    </td>
  );
};
CustomDataTableNotes.displayName = DataTableCell.displayName;

const Clients = () => {
  const dispatch = useDispatch();
  const { clients, loading, pagination } = useSelector(clientsSelector);
  const [sortColumn, setSortColumn] = useState('name');
  const [sortColumnDirection, setSortColumnDirection] = useState({
    name: 'asc',
  });
  const [items, setItems] = useState([]);
  const [accountsDropDown, setAccountsDropDown] = useState('0');
  const [hasMore, setHasMore] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [openAddClientModal, setOpenAddClientModal] = useState(false);
  const [paginated, setPaginated] = useState(0);

  useEffect(() => {
    dispatch(getClients());
  }, [dispatch]);

  useEffect(() => {
    if (clients.length > 0) {
      setItems(clients);
    }
  }, [clients]);

  const handleSort = (_sortColumn, ...rest) => {
    const { property: sortProperty, sortDirection } = _sortColumn;
    if (sortColumnDirection.name === sortDirection && sortProperty === sortColumn) {
      return;
    }
    setSortColumn(sortProperty);
    setSortColumnDirection({ name: sortDirection });

    // sorting will actually be handled from api
    // so dispatch sort action in useEffect
    // dispatch(sortAccounte({sortDirection, sortProperty}))
    // and the update the state with sorted accounts lists this will be done by above useEffect

    /**
     * For now handling from FED
     * later can be changed
     */
    let clone = [...items];

    clone.sort((a, b) => {
      if (!a[sortProperty]) {
        return 0;
      }
      if (typeof a[sortProperty] === 'string' && typeof b[sortProperty] === 'string') {
        return sortDirection === 'asc'
          ? a[sortProperty].localeCompare(b[sortProperty])
          : b[sortProperty].localeCompare(a[sortProperty]);
      }
      if (typeof a[sortProperty] === 'number' && typeof b[sortProperty] === 'number') {
        return sortDirection === 'asc'
          ? a[sortProperty] - b[sortProperty]
          : b[sortProperty] - a[sortProperty];
      }

      return 0;
    });

    if (JSON.stringify(clone) === JSON.stringify(items)) {
      return;
    }

    setItems(clone);
  };

  const hanldeClientAdd = (el) => {
    setOpenAddClientModal(true);
  };

  const handleLoadMore = () => {
    if (!loading && !isPageLoading) {
      setIsPageLoading(true);
      setTimeout(() => {
        if (!pagination.pages || pagination?.pages <= 1 || paginated >= pagination.pages) {
          setHasMore(false);
          setIsPageLoading(false);
          return;
        }

        if (pagination.currentPage >= pagination.pages) {
          setHasMore(false);
          setIsPageLoading(false);
          return;
        }
        let url = new URLSearchParams(pagination.nextPageUrl);
        setPaginated(paginated + 1);
        dispatch(getClients({ limit: url.get('limit'), offset: url.get('offset') }));
        setIsPageLoading(false);
      }, 1000);
    }
  };

  return (
    <div className="pageContent">
      <PageHeader
        icon={<img src="/assets/icons/pages/clients/users.svg" alt="hfm client page" />}
        info={` ${items.length} items • Recently updated`}
        joined
        label="Clients"
        title="All Clients"
        nameSwitcherDropdown={
          <Dropdown
            assistiveText={{ icon: 'Name Switcher' }}
            buttonClassName="slds-button_icon-small"
            buttonVariant="icon"
            iconCategory="utility"
            iconName="down"
            id="page-header-name-switcher-dropdown"
            options={[
              { label: 'Menu Item One', value: 'A0' },
              { label: 'Menu Item Two', value: 'B0' },
              { label: 'Menu Item Three', value: 'C0' },
              { label: 'Menu Item Four', value: 'D0' },
            ]}
          />
        }
        onRenderActions={() => (
          <>
            <PageHeaderControl>
              <ButtonGroup id="button-group-page-header-actions">
                <Button onClick={(el) => hanldeClientAdd(el)} label={'Add Client'} />
                <Dropdown
                  align="right"
                  assistiveText={{ icon: 'Checkmark' }}
                  checkmark
                  iconCategory="utility"
                  iconName="down"
                  iconVariant="border-filled"
                  id="page-header-dropdown-object-home-nav-right"
                  value={accountsDropDown}
                  onSelect={(selected) => setAccountsDropDown(selected.value)}
                  options={[
                    { label: 'Choose', value: '0' },
                    { label: 'Menu Item One', value: 'A0' },
                    { label: 'Menu Item Two', value: 'B0' },
                    {
                      label: 'Menu Item Three',
                      value: 'C0',
                    },
                    { type: 'divider' },
                    {
                      label: 'Menu Item Four',
                      value: 'D0',
                    },
                  ]}
                />
              </ButtonGroup>
            </PageHeaderControl>
          </>
        )}
        onRenderControls={controls}
        truncate
        variant="object-home"
      />
      <div style={{ height: '80vh' }}>
        <DataTable
          assistiveText={{
            actionsHeader: 'actions',
            columnSort: 'sort this column',
            columnSortedAscending: 'asc',
            columnSortedDescending: 'desc',
            selectAllRows: 'Select all rows',
            selectRow: 'Select this row',
          }}
          fixedHeader
          fixedLayout
          items={items}
          id="ClientsTable"
          onSort={handleSort}
          hasMore={hasMore}
          onLoadMore={handleLoadMore}
          noRowHover
        >
          <DataTableColumn
            isSorted={sortColumn === 'name'}
            label="Name"
            primaryColumn
            property="name"
            sortable
            sortDirection={sortColumnDirection.name}
            width="18rem"
          >
            <CustomDataTableCell />
          </DataTableColumn>
          <DataTableColumn label="Investment Size" property="deposit" sortable />
          <DataTableColumn
            sortable
            // isDefaultSortDescending
            label="Phone"
            property="contact"
          />
          <DataTableColumn
            isSorted={sortColumn === 'user'}
            label="Email"
            property="user"
            sortable
            sortDirection={sortColumnDirection.user}
          />
          <DataTableColumn label="Notes" property="notes" sortable>
            <CustomDataTableNotes />
          </DataTableColumn>
          <DataTableColumn label="Last Deposit Date" property="last_deposited_at" sortable />
        </DataTable>
      </div>
      <AddClient openModal={openAddClientModal} closeModal={() => setOpenAddClientModal(false)} />
    </div>
  );
};

export default Clients;
